import { TClientsPageMode } from 'types/state';
import { useRouteMatchStrict } from 'hooks/useRouteMatchStrict';
import { routes } from 'utils/routes';

export const useClientsPageMode = (): TClientsPageMode => {
  const { path: actualPath } = useRouteMatchStrict();

  switch (actualPath) {
    case routes.clientsPattern():
      return 'ACTIVE_CLIENTS';
    case routes.archivePattern():
      return 'ARCHIVED_CLIENTS';
    default:
      throw new TypeError();
  }
};
